import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { LatLngBounds } from 'leaflet';
import { RestStop } from '../models/rest-stop';
import { MapFilters } from './filter.service';

@Injectable({
  providedIn: 'root',
})
export class RestStopService {
  http = inject(HttpClient);

  private markerClickSource = new Subject<RestStop>();
  markerClicked$ = this.markerClickSource.asObservable();

  addRaststaette(data: any): Observable<any> {
    return this.http.post(`${environment.backend}/raststaetten`, data);
  }

  getRaststaetten(bounds: LatLngBounds, filters: MapFilters): Observable<RestStop[]> {
    let params = new HttpParams()
      .set('north', bounds.getNorthEast().lat.toString())
      .set('south', bounds.getSouthWest().lat.toString())
      .set('east', bounds.getNorthEast().lng.toString())
      .set('west', bounds.getSouthWest().lng.toString())
      .set('minRating', filters.minRating.toString())

      .set('playground', filters.playground.toString())
      .set('restaurant', filters.restaurant.toString())
      .set('gasStation', filters.gasStation.toString())
      .set('kiosk', filters.kiosk.toString())
      .set('shower', filters.shower.toString())
      .set('wifi', filters.wifi.toString())
      .set('picnicArea', filters.picnicArea.toString())
      .set('chargingStation', filters.chargingStation.toString())
      .set('atm', filters.atm.toString())
      .set('vendingMachine', filters.vendingMachine.toString())
      .set('isFee', filters.isFee.toString());

    if (filters.price !== null && filters.price !== undefined) {
      params = params.set('price', String(filters.price));
    }

    return this.http.get<RestStop[]>(`${environment.backend}/raststaetten`, { params });
  }

  notifyMarkerClick(stop: RestStop) {
    this.markerClickSource.next(stop);
  }

  getRestStopsByIds(ids: number[]): Observable<RestStop[]> {
    const params = new HttpParams().set('ids', ids.join(','));
    return this.http.get<RestStop[]>(`${environment.backend}/raststaetten/by-ids`, { params });
  }

  getRestStopBySlug(slug: string): Observable<RestStop> {
    return this.http.get<RestStop>(`${environment.backend}/raststaetten/slug/${slug}`);
  }

  getNearestRestStops(lat: number, lng: number, heading: number | null): Observable<RestStop[]> {
    let params = new HttpParams().set('lat', lat.toString()).set('lng', lng.toString());

    if (heading !== null) {
      params = params.set('heading', heading.toString());
    }

    return this.http.get<RestStop[]>(`${environment.backend}/raststaetten/nearest`, { params });
  }

  getRestStopBySearch(name: string): Observable<RestStop[]> {
    return this.http.get<RestStop[]>(`${environment.backend}/raststaetten/search`, { params: { searchTerm: name } });
  }
}
